var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarred(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3638 2.22209L8.2437 3.99644C8.3637 4.24344 8.6837 4.48035 8.9536 4.5257L10.5485 4.7929C11.5684 4.9643 11.8083 5.7103 11.0734 6.4462L9.8335 7.6964C9.6236 7.9081 9.5086 8.3164 9.5736 8.6087L9.9285 10.1562C10.2085 11.3812 9.5636 11.855 8.4887 11.2148L6.9939 10.3226C6.7239 10.1613 6.2789 10.1613 6.004 10.3226L4.50913 11.2148C3.43925 11.855 2.78932 11.3761 3.06929 10.1562L3.42425 8.6087C3.48925 8.3164 3.37426 7.9081 3.16428 7.6964L1.92442 6.4462C1.1945 5.7103 1.42947 4.9643 2.44936 4.7929L4.04419 4.5257C4.30916 4.48035 4.62912 4.24344 4.74911 3.99644L5.629 2.22209C6.109 1.2593 6.8889 1.2593 7.3638 2.22209Z",
    stroke: "#616874",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarred);
export default __webpack_public_path__ + "static/media/starred.7604b2a980e0ecd45547aff88ade6212.svg";
export { ForwardRef as ReactComponent };